// Default editable texts for the owner-facing pages (Conciergerie + Estimation).
export const OWNER_TEXTS = {
  concierge_hero_eyebrow: "Conciergerie à Rouen",
  concierge_hero_title: "Votre conciergerie à Rouen",
  concierge_services_title: "Une gestion complète, sans souci",
  concierge_services_intro: "De la mise en ligne au ménage, nous prenons soin de votre bien comme s'il était le nôtre.",
  concierge_steps_title: "Simple, en 4 étapes",
  concierge_cta_title: "Prêt à valoriser votre logement ?",
  concierge_cta_subtitle: "Demandez une estimation gratuite et sans engagement.",
  entrust_eyebrow: "Confiez-nous votre logement",
  entrust_title: "Demander une estimation gratuite",
  entrust_subtitle: "Renseignez les informations de votre logement, nous étudions son potentiel et vous recontactons.",
};

// Editable trust badges: Google rating band + Tourist Office partner block.
export const TRUST_DEFAULTS = {
  google_rating: "",
  google_rating_label: "Note Google",
  show_google_rating: false,
  partner_eyebrow: "Reconnaissance officielle",
  partner_title: "Partenaire officiel de l'Office de Tourisme de Rouen",
  partner_text: "NJ Conciergerie est référencée par l'Office de Tourisme Rouen Normandie — un gage de sérieux et d'ancrage local pour les propriétaires comme pour les voyageurs.",
  partner_url: "https://www.visiterouen.com/offres/la-conciergerie-rouen-fr-5968811/",
  show_partner: true,
};

export const TRUST_TEXT_FIELDS = [
  { k: "google_rating", label: "Note Google (ex. 4,5)" },
  { k: "google_rating_label", label: "Libellé sous la note (ex. Note Google)" },
  { k: "partner_eyebrow", label: "Partenaire · Sur-titre" },
  { k: "partner_title", label: "Partenaire · Titre" },
  { k: "partner_text", label: "Partenaire · Texte", long: true },
  { k: "partner_url", label: "Partenaire · Lien de la fiche" },
];

// "NJ Conciergerie en chiffres" — social-proof band. Hidden until the client fills real numbers.
export const STATS_DEFAULTS = {
  show: false,
  title: "NJ Conciergerie en chiffres",
  subtitle: "Des résultats concrets pour les propriétaires rouennais.",
  items: [
    { id: "logements", value: "", label: "Logements gérés à Rouen" },
    { id: "occupation", value: "", label: "Taux d'occupation moyen" },
    { id: "voyageurs", value: "", label: "Voyageurs accueillis" },
    { id: "note", value: "", label: "Note moyenne voyageurs" },
    { id: "experience", value: "", label: "Années d'expérience locale" },
  ],
};

// Case studies for /resultats-proprietaires. Ships one anonymised, editable example.
export const CASE_STUDIES_DEFAULTS = {
  intro: "Chaque logement a son histoire. Voici, en toute transparence, comment nous transformons un bien en revenu locatif optimisé à Rouen. Exemple anonymisé et représentatif de notre méthode.",
  items: [
    {
      id: "exemple-1",
      hidden: false,
      title: "Appartement T2 — Rouen Centre",
      type: "T2 · 45 m² · résidence principale (120 nuits/an)",
      quartier: "Rouen Centre — secteur Vieux-Marché",
      situation: "Le propriétaire gérait seul son appartement sur une seule plateforme. Annonce peu optimisée, photos au smartphone, prix fixe toute l'année et beaucoup de temps passé à répondre aux voyageurs. Taux d'occupation faible et avis irréguliers.",
      actions: [
        "Reportage photo professionnel et réécriture complète de l'annonce",
        "Diffusion sur Airbnb, Booking.com et en réservation directe, calendriers synchronisés",
        "Tarification dynamique ajustée chaque jour selon la demande et les événements rouennais",
        "Accueil des voyageurs 7j/7, ménage hôtelier et linge fournis entre chaque séjour",
      ],
      results: [
        { k: "Taux d'occupation", before: "≈ 45 %", after: "≈ 78 %" },
        { k: "Revenus mensuels moyens", before: "620 €", after: "1 180 €" },
        { k: "Note voyageurs", before: "4,3 / 5", after: "4,9 / 5" },
      ],
      quote: "Je ne m'occupe plus de rien et mes revenus ont quasiment doublé. — Propriétaire, Rouen Centre",
    },
  ],
};

export const OWNER_TEXT_FIELDS = [
  { k: "concierge_hero_eyebrow", label: "Conciergerie · Sur-titre du bandeau" },
  { k: "concierge_hero_title", label: "Conciergerie · Titre du bandeau" },
  { k: "concierge_services_title", label: "Conciergerie · Titre section services" },
  { k: "concierge_services_intro", label: "Conciergerie · Intro services", long: true },
  { k: "concierge_steps_title", label: "Conciergerie · Titre section étapes" },
  { k: "concierge_cta_title", label: "Conciergerie · Titre appel à l'action" },
  { k: "concierge_cta_subtitle", label: "Conciergerie · Sous-titre appel à l'action", long: true },
  { k: "entrust_eyebrow", label: "Estimation · Sur-titre" },
  { k: "entrust_title", label: "Estimation · Titre" },
  { k: "entrust_subtitle", label: "Estimation · Sous-titre", long: true },
];
